import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useState, useEffect } from "react";

import UserListPage from "../user/UserListPage";

const ContactsListPage = (props) => {
  const history = useHistory();
  const [sortParams, setSortParams] = useState(() => {
    const queryParams = new URLSearchParams(history.location.search);
    return {
      sortBy: queryParams.get("sort") || "",
      sortDir: queryParams.get("sort_dir") || "asc",
    };
  });
  const columns = [
    { id: "first_name", width: "24%", minWidth: "168px" },
    {
      id: "email",
      width: "30%",
      minWidth: "210px",
      cell: (row) => (
        <div className="text-primary truncate">
          {!row?.email ? "-" : row.email}
        </div>
      ),
    },
    { id: "phone", width: "22%", minWidth: "154px" },
    {
      id: "orgName",
      width: "20%",
      minWidth: "140px",
      cell: (row) => (
        <div
          className="cursor-pointer text-primary truncate"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {!row?.organization?.name ? (
            "-"
          ) : (
            <Link
              className="table-link truncate"
              to={`/organization/${row.org_id}`}
            >
              {row.organization.name}
            </Link>
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    const params = new URLSearchParams(history.location.search);

    if (sortParams.sortBy) {
      params.set("sort", sortParams.sortBy);
      params.set("sort_dir", sortParams.sortDir);
    } else {
      params.delete("sort");
      params.delete("sort_dir");
    }

    history.replace({
      pathname: history.location.pathname,
      search: params.toString(),
    });
  }, [sortParams, history]);

  return (
    <UserListPage
      {...props}
      userList={props.contactList}
      columns={columns}
      endpoint="/contacts"
      searchEndpoint="/contacts/search"
      title="Contacts"
      icon={faUser}
      newItemPath="/contact-add"
      setSortParams={setSortParams}
      sortParams={sortParams}
      defaultSortFieldId={sortParams?.sortBy}
      defaultSortAsc={sortParams?.sortDir !== "desc"}
    />
  );
};

export default ContactsListPage;
